function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.335,
  d: "M0.215057 8.44714L3.65406 5.00014L0.215057 1.55314L1.27406 0.494141L5.78006 5.00014L1.27406 9.50614L0.215057 8.44714Z",
  fill: "#63738E"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.652,
  d: "M5.21994 8.44714L8.65894 5.00014L5.21994 1.55314L6.27894 0.494141L10.7849 5.00014L6.27894 9.50614L5.21994 8.44714Z",
  fill: "#63738E"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.2199 8.44714L13.6589 5.00014L10.2199 1.55314L11.2789 0.494141L15.7849 5.00014L11.2789 9.50614L10.2199 8.44714Z",
  fill: "#63738E"
});

var SvgIconTripleArrows = function SvgIconTripleArrows(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTripleArrows, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_triple_arrows.e7a86e65.svg";
export { ForwardRef as ReactComponent };